import React, { useEffect } from 'react';

import { AppIcon, AppList } from '@capcenter/shared';
import { useRecoilValue } from 'recoil';
import * as AppState from '../../AppState';

const app = 'homeSearch';

export default function AppHeader() {
	const gsFilters = useRecoilValue(AppState.gsFilters);
	const gsUserLocation = useRecoilValue(AppState.gsUserLocation);
	const [propertyTypeString, setPropertyTypeString] = React.useState('');
  const cityOrCounty = gsUserLocation.city ? gsUserLocation.city : gsUserLocation.county ? gsUserLocation.county : '';


	useEffect(() => {
		if (gsFilters.propertyType === 'ForSale') {
      if(gsFilters.openHouse){
        setPropertyTypeString('Open houses')
      } else{
			  setPropertyTypeString('Homes for sale');
      }
		}
		else if (gsFilters.propertyType === 'CapCenterRealty' || gsFilters.propertyType === 'CapCenterClosed') {
			setPropertyTypeString('Homes closed with CapCenter');
		} else {
			setPropertyTypeString('Recently sold homes');
		}
	}, [gsFilters.propertyType]);

	return (
		<React.Fragment>
			<div className="d-flex flex-wrap align-items-center justify-content-start justify-content-lg-center justify-content-xl-start">
				<div className="d-flex flex-lg-wrap flex-xl-nowrap align-items-center lh-1 pe-2">
					<div className="d-inline-block me-2 mx-lg-auto flex-shrink-0" style={{ width: 22 }}>
						<AppIcon app={(AppList as any)[app]} />
					</div>
					<h1
						className="fw-bold lh-1 text-lg-center text-xl-start mt-lg-1 mt-xl-0 mb-0 ps-1"
						style={{ fontSize: '1.375rem', color: '#213035' }}
					>
						{propertyTypeString}
						{(cityOrCounty || gsUserLocation?.state) && (
							<React.Fragment>
								&nbsp;in<span className='text-capitalize'> {cityOrCounty}{cityOrCounty && gsUserLocation.state && ', '}<span className='text-uppercase'>{gsUserLocation.state}</span></span>
							</React.Fragment>
						)}
						{/* {locationString.length > 0 && {
              locationString,
            }} */}
					</h1>
				</div>
			</div>
		</React.Fragment>
	);
}
